import { TExcludedCommoditiesSchema } from '../components/ExcludedCommoditiesModal/schema/ExcludedCommoditiesSchema'
import { IExcludedCommodities } from '../components/ExcludedCommoditiesModal/types'

export const getExcludedCommoditiesDefaultValues = (
  excludedCommodities: string[]
): TExcludedCommoditiesSchema => {
  return {
    alcohol: excludedCommodities.includes(IExcludedCommodities.ALCOHOL),
    babyFood: excludedCommodities.includes(IExcludedCommodities.BABY_FOOD),
    cosmetic: excludedCommodities.includes(IExcludedCommodities.COSMETIC),
    electronic: excludedCommodities.includes(IExcludedCommodities.ELECTRONIC),
    garment: excludedCommodities.includes(IExcludedCommodities.GARMENT),
    jewelry: excludedCommodities.includes(IExcludedCommodities.JEWELRY),
    meat: excludedCommodities.includes(IExcludedCommodities.MEAT),
    medication: excludedCommodities.includes(IExcludedCommodities.MEDICATION),
    metal: excludedCommodities.includes(IExcludedCommodities.METAL),
    seafood: excludedCommodities.includes(IExcludedCommodities.SEAFOOD),
    tobacco: excludedCommodities.includes(IExcludedCommodities.TOBACCO),
  }
}
